import { Directive, HostBinding, HostListener, Output, EventEmitter } from '@angular/core';
import { DomSanitizer , SafeUrl} from '@angular/platform-browser';

export interface FileHandle {
  file: File
}
@Directive({
  selector: '[appDragDrop]'
})
export class DragDropDirective {
@Output() files: EventEmitter<FileHandle[]> = new EventEmitter();


  constructor(private sanitizer: DomSanitizer) { }

  @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();

    let files: FileHandle[] = [];
    for (let i = 0; i < evt.dataTransfer.files.length; i++) {
      const file = evt.dataTransfer.files[i];
      files.push({ file });
    }
    if (files.length > 0) {
      this.files.emit(files);
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/link-code/drag-drop.directive.ts